// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"597":"5a9b53b9","759":"9929007a","782":"7f09feab"}[chunkId] + ".js";
};